module.exports = __webpack_public_path__ + "img/calendar-clock.d6b3a0d8.svg";